import AboutController from './controllers/AboutController';
import module from './module';
import routes from './routeConfig';

module.controller('Cartonomy.About.AboutController', AboutController);

module.config([
    '$stateProvider',
    function ($stateProvider) {
        routes.forEach(route => {
            $stateProvider
                .state(route);
        });
    }
]);

export default module.name;


// WEBPACK FOOTER //
// ./src/modules/about/index.js